import { SprintOutcomes } from 'features/planning/components/Board/Sprint/Header/Outcomes/SprintOutcomes';
import { useUserId } from 'features/user/hooks/useUserId';

export const PlanningSprintHeaderOutcomesContent = ({
  sprintId,
}: {
  sprintId: string;
}) => {
  const userId = useUserId();

  if (!userId) {
    return null;
  }

  return <SprintOutcomes sprintId={sprintId} userId={userId} />;
};
